module.exports = __webpack_public_path__ + "img/iStock-154954447.334a9286.jpg";